import AddItem from './components/AddItem';
import List from './components/List';
import {v4 as uuidv4} from 'uuid';
import {Profiler, useCallback, useEffect, useMemo, useState} from "react";
// import Clear from "./components/Clear";
import createClient from "openapi-fetch";
import {paths, SchemaItem} from "./listan-backend-api";
import NewList from "./components/NewList";
import MyPage from "./components/MyPage";
import Lists from "./components/Lists";
import UndoRemoveButton from "./components/UndoRemoveButton";
import EditableListName from "./components/EditableListName";
import ListOptionsMenu from "./components/ListOptionsMenu";
import {
    CheckedItemPosition,
    CheckedItemsListSortOrder,
    ListOptions,
    ListsViewSettings,
    ListsViewSort
} from "./ClientSidetypes";
import ListsViewMenu from "./components/ListsViewSettings";
import CheckedItemsList from "./components/CheckedItemsList";
import WakeLockButton from "./components/WakeLockButton";
import activeRequests from './active-requests';

activeRequests.start({debug: true});

const defaultListItems: SchemaItem[] = [];

const client = createClient<paths>();
const params = new URLSearchParams(window.location.search);

if (!params.get('listid')) {
    window.location.href =  window.location.protocol + "//" + window.location.host;
    // We are doing a redirect so let's halt the rest of the javascript.
    throw new Error("");
}


function getPathTo(element : HTMLElement | EventTarget | null) : string | undefined {
    if (!(element instanceof HTMLElement)) {
        return undefined;
    }

    if (element === document.body)
        return element.tagName

    if (element.parentNode === null)
        return element.tagName

    var ix= 0;
    var siblings= element.parentNode.childNodes;

    for (var i= 0; i < siblings.length; i++) {
        var sibling= siblings[i];

        if (sibling === element) {
            return getPathTo(element.parentNode as HTMLElement) + '/' + element.tagName + '[' + (ix + 1) + ']'
        }

        if (sibling instanceof HTMLElement && sibling.tagName === element.tagName) {
            ix++
        }
    }
}

document.addEventListener('click', (event) => {

    // var outerHTML = event.target.outerHTML;
    //
    // if (outerHTML.length > 120) {
    //     outerHTML = outerHTML.substring(0,100) + "... (was " + outerHTML.length + ")";
    // }
    //
    // console.log("\"" + outerHTML + "\" clicked, xpath: \"" + getPathTo(event.target) + "\"", event.target);

    console.log("click on \" xpath: \"" + getPathTo(event.target) + "\", clientX: " + event.clientX + ", clientY: " + event.clientY);

}, {once: false});

function App() {

    /*

        Listening for clicks on document makes it possible to have focus
        get lost when clicking outside of an input on IOS.

        Without this we don't lose focus when clicking outside the body.

        It's a bit magical =)
     */
    useEffect(() => {
        const onClickHandler = () => {}

        document.addEventListener('click', onClickHandler);
        return () => {
            document.removeEventListener('click', onClickHandler);
        }
    }, []);


    const [listViewSettings, setListViewSettings] = useState(
        (
            window.localStorage.getItem("listViewSettings") !== null ?
                JSON.parse(window.localStorage.getItem("listViewSettings")!) :
                {
                    sortOrderHistory: [
                        {sortBy: ListsViewSort.ModifiedAt},
                        {sortBy: ListsViewSort.CheckedCount},
                        {sortBy: ListsViewSort.Size},
                        {sortBy: ListsViewSort.Name},
                        {sortBy: ListsViewSort.CreatedAt},
                    ]
                }
        ) as ListsViewSettings
    )
    const [listLastModifiedAt, setListLastModifiedAt] = useState(new Date());
    const [lastRemoveDoneAt, setLastRemoveDoneAt] = useState(new Date());
    const [currentPage, setCurrentPage] = useState("item-list-page");
    const [showListSettings, setShowListSettings] = useState(false);
    const [showListsViewSettings, setShowListsViewSettings] = useState(false);
    const [listItems, setListItems] = useState(defaultListItems);
    const [listName, setListName] = useState("");
    const [listHasBeenRemoved, setListHashBeenRemoved] = useState(false);
    const [listid, setListid] = useState(params.get('listid')!);

    const defaultListOptions = useMemo(() => {
        return {
            groupByType: false,
            moveCheckedToEnd: false,
          playSoundWhenCheckedAndUncheked: false,
          checkedItemPosition: CheckedItemPosition.InPlace,
          checkedItemsListSortOrder: CheckedItemsListSortOrder.CheckedAt
        } as ListOptions
    }, []);

    const [listOptions, setListOptions] = useState(
        (
            window.localStorage.getItem("listOptions") !== null ?
                JSON.parse(window.localStorage.getItem("listOptions")!) : defaultListOptions
        ) as ListOptions
    );

    const fetchList = useCallback((andNavigate: boolean = false) => {
        client.GET("/api/list/{listid}/items", {
            params: {
                path: {
                    listid: listid
                }
            }
        }).then((result) => {
            if (result.response.ok && result.data) {

                setListName(result.data.listName);
                setListHashBeenRemoved(result.data.hasBeenRemoved);

                setListItems(currentList => {

                    const currentListSizeBeforeAnyDelete = currentList.length;

                    // 1. Remove items not in both lists
                    currentList = currentList.filter((item) => {
                        return item.id.startsWith("new-") || result.data.items.filter((serverItem) => serverItem.id === item.id).length > 0;
                    });

                    if (currentList.length < currentListSizeBeforeAnyDelete) {
                        setLastRemoveDoneAt(new Date());
                    }

                    // 2. Update items
                    currentList = currentList.map((item) => {
                        const serverVersion =  result.data.items.filter((serverItem) => (serverItem.id === item.id && serverItem.version > item.version));
                        if (serverVersion.length === 1) {
                            return serverVersion[0];
                        } else {
                            return item;
                        }
                    });

                    // 3. Copy over the items that are not in the current list
                    const newItemsFromServer = result.data.items.filter((serverItem) => {
                        return currentList.filter((item) => serverItem.id === item.id).length === 0;
                    });

                    return [...currentList, ...newItemsFromServer].sort((a, b) => {
                        if (new Date(a.addedAt) === new Date(b.addedAt)) {
                            return 0;
                        }

                        if (new Date(a.addedAt) > new Date(b.addedAt)) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });
                });

                setListLastModifiedAt(new Date(result.data.listLastModifiedAt));
                if (andNavigate) {
                    // Super ugly hack to get the navigation to happen after rendering
                    setTimeout(() => {
                        setCurrentPage("item-list-page");
                    }, 10);
                }

                const element = document.getElementById('display-none-styling');
                if(element) {
                    element.remove();
                }
            }

            if (result.response.status === 404 || result.response.status === 400) {
                window.location.href =  window.location.protocol + "//" + window.location.host;
            }
        }).catch(console.error);
    }, [setListItems, setListHashBeenRemoved, setListName, listid])

    useEffect(() => {
        const interval = setInterval(() => {
            client.GET("/api/list/{listid}/lastModifiedAt", {
                params: {
                    path: {
                        listid: listid
                    }
                }
            })
                .then((result) => {
                    if (result.response.ok && result.data) {
                        const lastModifiedAt = new Date(result.data.listLastModifiedAt);

                        if (lastModifiedAt > listLastModifiedAt) {
                            console.log("Fetch fetthch");
                            fetchList();
                        }
                    }
                })
                .catch(console.error);
        }, 1000)

        return () => clearInterval(interval)
    }, [listLastModifiedAt, listid, fetchList])

    useEffect(() => {
        fetchList(true);
        if (window.localStorage.getItem("listOptions") !== null) {
            setListOptions(JSON.parse(window.localStorage.getItem("listOptions")!) as ListOptions);
        } else {
            setListOptions(defaultListOptions as ListOptions);
        }
    }, [listid, fetchList, defaultListOptions]);

    useEffect(() => {
        setShowListSettings(false);
    }, [currentPage]);

    const getLocalTimezoneISOString = () => {
        return (new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString()).replaceAll("Z", "");
    }

    function addToList(text: string): void {
        const item = {id: "new-" + uuidv4(), text: text, checked: false, version: 1, addedAt: getLocalTimezoneISOString(), removed: false} as SchemaItem;
        setListItems(currentList => [...currentList, item]);

        client.POST("/api/list/{listid}/items", {
            params: {
                path: {
                    listid: listid
                }
            },
            body: {
                text: item.text,
                clientUUID: item.id
            }
        }).then((result) => {
            if (result.data) {
                setListItems(currentList => {
                    return currentList.map((item) => {
                        if (item.id === result.data.clientUUID) {
                           return {...item, id: result.data.serverUUID, addedAt: result.data.addedAt};
                        }

                        return item;
                    });
                });
            }
        }).catch(console.error);

    }

    function removeItem(uuid: string) {
        setListItems(currentList => {
            currentList = currentList.map((item) => {
                if (item.id === uuid) {
                    return {...item, removed: true}
                }

                return item;
            });

            return [...currentList];
        });


        client.DELETE("/api/items/{uuid}", {
            params: {
                path: {
                    uuid: uuid
                }
            }
        }).then(response => {
            setLastRemoveDoneAt(new Date());
            if (response.error) {
                console.error(response);
            }
        }).catch(console.error);
    }

    function setCheckStatus(uuid: string, checked: boolean) {
        setListItems(currentList => {
            return currentList.map((item) => {
                if (item.id === uuid) {
                    return {...item, checked: checked, checkedLastChangedAt: new Date().toISOString()};
                }

                return item;
            });
        });

        if (checked) {
            client.POST("/api/items/{uuid}/check", {
                params: {
                    path: {
                        uuid: uuid
                    }
                }
            }).then(response => {
                if (response.error) {
                    console.error(response);
                }
            }).catch(console.error);

        } else {
            client.POST("/api/items/{uuid}/uncheck", {
                params: {
                    path: {
                        uuid: uuid
                    }
                }
            }).then(response => {
                if (response.error) {
                    console.error(response);
                }
            }).catch(console.error);
        }
    }

    const undoCallback = () => {
        fetchList();
    };

    const updateItemText = (uuid: string, text: string) => {
        let previousTextValue = "???";

        setListItems(currentList => {
            return currentList.map((item) => {
                if (item.id === uuid) {
                    previousTextValue = item.text;

                    return {...item, text: text};
                }

                return item;
            });
        });

        client.POST("/api/items/{uuid}/changeText", {
            params: {
                path: {
                    uuid: uuid
                },
            },
            body: {
                text: text
            }
        }).then((result) => {
            if (!result.response.ok) {
                // Given that we failed on the server we reset it to the previous value
                setListItems(currentList => {
                    return currentList.map((item) => {
                        if (item.id === uuid) {
                            return {...item, text: previousTextValue}
                        }

                        return item;
                    });
                });
                console.error(result);
            }
        }).catch(console.error);
    };

    const onListNameChange = (newListName: string) => {
        setListName(newListName);

        client.POST("/api/{listId}/changeName", {
            params: {
                path: {
                    listId: listid
                }
            },
            body: {
                listName: newListName
            }
        }).catch(console.error);
    };

    const navigateToList = (listId: string)=> {
        if (window.location.href.indexOf(listId) !== -1) {
            fetchList(true);
        } else {
            window.history.replaceState("", "", "/index.html?listid=" + listId);
            setListid(listId);
        }
    };

    const onListOptionsChange = (listOptions: ListOptions) => {
        setListOptions(listOptions);
        window.localStorage.setItem("listOptions", JSON.stringify(listOptions));
    }

    const onListsViewSettingsChange = (listsViewSettings: ListsViewSettings) => {
        setListViewSettings(listsViewSettings);
        window.localStorage.setItem("listViewSettings", JSON.stringify(listsViewSettings));
    }

    const removeAllCheckedItems = () => {
        setListItems(currentList => {
            currentList = currentList.map((item) => {
                if (item.checked) {
                    return {...item, removed: true}
                }

                return item;
            });

            return [...currentList];
        });


        client.DELETE("/api/list/{listid}/check_items", {
            params: {
                path: {
                    listid: listid
                }
            }
        }).then(response => {
            setLastRemoveDoneAt(new Date());
            if (response.error) {
                console.error(response);
            }
        }).catch(console.error);
    }

    const removeAllItems = () => {
        setListItems([]);

        client.DELETE("/api/list/{listid}/items", {
            params: {
                path: {
                    listid: listid
                }
            }
        }).then(response => {
            setLastRemoveDoneAt(new Date());
            if (response.error) {
                console.error(response);
            }
        }).catch(console.error);
    }

    const removeList = () => {
        client.PATCH("/api/list/{listid}", {
            params: {
                path: {
                    listid: listid
                }
            },
            body: {
                removed: true
            }

        }).then(response => {
            if (response.error) {
                console.error(response);
                setListHashBeenRemoved(false);
            } else {
                fetchList();
            }
        }).catch(console.error);

        setShowListSettings(false);
        setListHashBeenRemoved(true);
    };

    const undoRemoveList = () => {
        client.PATCH("/api/list/{listid}", {
            params: {
                path: {
                    listid: listid
                }
            },
            body: {
                removed: false
            }

        }).then(response => {
            if (response.error) {
                console.error(response);
                setListHashBeenRemoved(true);
            } else {
                fetchList();
            }
        }).catch(console.error);

        setListHashBeenRemoved(false);
    };

    const handleProfilerData = (
        id: any, // the "id" prop of the Profiler tree
        phase: string, // "mount" or "update"
        actualDuration: number, // time spent rendering
        baseDuration: any, // estimated time for a full render
        startTime: number, // when React began rendering
        commitTime: number // when React committed the updates
    ) => {
        console.log("phase: " + phase + ", took: " + actualDuration.toFixed(2) + ", startTime: " + startTime.toFixed(2) + ", commitTime: " + commitTime.toFixed(2));
    };

    return (
        <Profiler id={"App"} onRender={handleProfilerData}>
            <MyPage pageClassName={"item-list-page"} pageName={"item-list-page"} selectedPageName={currentPage}>
                <header>
                    <button id={"lists-button"} onClick={() => {setCurrentPage("lists-page")}}>Listor</button>
                    <EditableListName disabled={listHasBeenRemoved} listName={listName} onListNameChange={onListNameChange} />
                    <button disabled={listHasBeenRemoved} className={showListSettings ? "showListSettingsTrue" : ""} id={"settings-button"} onClick={() => {setShowListSettings(!showListSettings)}}>Inställningar</button>
                </header>

                {
                    listHasBeenRemoved ?
                        <div className={"undoRemoveListButton-container"}>
                            <button className={"undoRemoveListButton"} onClick={undoRemoveList}>
                                Återställ listan
                            </button>
                        </div>
                        : <></>
                }

                {
                    showListSettings ? <ListOptionsMenu
                        removeList={removeList}
                        removeAllCheckedItems={removeAllCheckedItems}
                        removeAllItems={removeAllItems}
                        onChange={onListOptionsChange}
                        currentOptions={listOptions}
                        hasBeenRemoved={listHasBeenRemoved}
                    /> : ""
                }


                <menu>
                    <WakeLockButton disabled={listHasBeenRemoved} />
                    <UndoRemoveButton disabled={listHasBeenRemoved} listid={listid} undoCallback={undoCallback} lastRemoveDoneAt={lastRemoveDoneAt} />
                </menu>


                <menu>
                    <AddItem disabled={listHasBeenRemoved} addToList={addToList} />
                </menu>

                <List disabled={listHasBeenRemoved} listOptions={listOptions} updateItemText={updateItemText} items={listItems} setCheckStatus={setCheckStatus} removeItem={removeItem} />
                <CheckedItemsList disabled={listHasBeenRemoved} onChange={onListOptionsChange} listOptions={listOptions} updateItemText={updateItemText} items={listItems} setCheckStatus={setCheckStatus} removeItem={removeItem} />
                <UndoRemoveButton disabled={listHasBeenRemoved} listid={listid} undoCallback={undoCallback} lastRemoveDoneAt={lastRemoveDoneAt} />
                {/*<Clear items={listItems} clearList={clearList} />*/}
                <footer>
                    <AddItem disabled={listHasBeenRemoved} addToList={addToList} />
                    <UndoRemoveButton disabled={listHasBeenRemoved} listid={listid} undoCallback={undoCallback} lastRemoveDoneAt={lastRemoveDoneAt} />
                </footer>
            </MyPage>



            <MyPage pageClassName={"lists-page"} pageName={"lists-page"} selectedPageName={currentPage}>
                <header>
                    <h1>Listor</h1>
                    <button className={"lists-menu " + (showListsViewSettings ? "showListSettingsTrue" : "")} onClick={() => setShowListsViewSettings(!showListsViewSettings)}>Meny</button>
                    <NewList />
                </header>

                {showListsViewSettings ? <ListsViewMenu currentOptions={listViewSettings} onChange={onListsViewSettingsChange} /> : ""}

                <Lists listsViewSettings={listViewSettings} navigateToList={navigateToList} shouldRefresh={currentPage === "lists-page"} />
                <footer>
                    <NewList />
                </footer>
            </MyPage>
        </Profiler>
    );
}

export default App;
